import Component from './setting_group_billing.vue'
export default Component
